import { AppSetting, Customer } from "../models";
import { parseQuickBooksTaxCodeSetting } from "./quick-books-tax-code";

export const resolveTaxRate = (
  defaultTaxSetting?: AppSetting,
  customer?: Pick<
    Customer,
    "quickbooksTaxCodeId" | "quickbooksTaxCodeName" | "quickbooksTaxRate"
  >
) => {
  if (customer?.quickbooksTaxCodeId) {
    return Number(customer.quickbooksTaxRate ?? 0);
  }

  return Number(parseQuickBooksTaxCodeSetting(defaultTaxSetting)?.rate ?? 0);
};
